import { useEffect, useState } from 'react'

import asyncAction from './asyncAction'
import { apiClient } from './mobx-rest'

export const useIsBecome = () => {
  const [isBecome, setIsBecome] = useState(false)

  useEffect(() => {
    const fetchIsBecome = async () => {
      const { value } = await asyncAction(() => apiClient().get('/accesses/become'), {
        successFlash: false,
        errorFlash: false,
      })
      setIsBecome(Boolean(value?.become))
    }

    fetchIsBecome()
  }, [])

  return isBecome
}
